<div class="popupContainer">
  <div class="headingDiv d-flex justify-content-between">
    @if(data.row!=undefined && !data.new){
    <span class="headingText">Edit DPNF Details</span>}@else{
    <div class="d-flex justify-content-between heading-details">
      <span class="headingText">Add to DPNF</span>
      <span class="headingText">(Last Refreshed Date- {{lastRefreshedDate}})</span>
    </div>
    }
    <div class="img-div" mat-dialog-close>
      <img src="../../../../../assets/images/crossIconDarkTheme.svg" style="width: 0.65rem" />
    </div>
  </div>
  @if(isMobile){
  <div class="container-head d-flex justify-content-center">
    @if(stepperCount==1 ){
    <div class="Allsteps stepActive" [ngClass]="stepperOneDone ? 'stepOneDone' : ''"
      [ngClass]="stepperCount == 1 && stepperTwoDone ? 'stepActive' : ''"></div>
    <!-- <span class="stepperText-active">Personal Info</span> -->

    <div class="Allsteps"></div>
    <!-- <span class="stepperText-active">Address Info</span> -->

    <div class="Allsteps"></div>

    } @else if(stepperCount==2 || (stepperCount == 2 && stepperTwoDone) ){
    <div class="Allsteps stepActive" [ngClass]="stepperOneDone ? 'stepOneDone' : ''"></div>
    <!-- <span class="stepperText-active">Personal Info</span> -->

    <div class="Allsteps stepActive" [ngClass]="stepperTwoDone ? 'stepTwoDone' : ''"
      [ngClass]="stepperCount == 2 && stepperTwoDone ? 'stepActive' : ''"></div>
    <!-- <span class="stepperText-active">Address Info</span> -->

    <div class="Allsteps"></div>

    } @else{
    <div class="Allsteps stepActive" [ngClass]="stepperOneDone ? 'stepOneDone' : ''"></div>
    <!-- <span class="stepperText-active">Personal Info</span> -->

    <div class="Allsteps stepActive" [ngClass]="stepperTwoDone ? 'stepTwoDone' : ''"></div>
    <!-- <span class="stepperText-active">Address Info</span> -->

    <div class="Allsteps stepActive"></div>
    }
  </div>
  }@else{
  <div class="container-head d-flex">
    @if(stepperCount==1){
    <div class="stepperHeading">
      <img src="../../../../../assets/images/tick.svg" class="circle-image-active" />
      <span class="stepperText-active">Personal Info</span>
      <span class="separator-step"></span>
    </div>
    }@else if(stepperCount!=1 ){
    <div class="stepperHeading" (click)="onInfoClick()">
      @if(stepperOneDone ){
      <img src="../../../../../assets/images/tick.svg" class="circle-image-active" />} @else{
      <img src="../../../../../assets/images/tick.svg" class="circle-image" />
      }
      <span class="stepperText">Personal Info</span>
      <span class="separator-step"></span>
    </div>
    } @if(stepperCount==2 ){
    <div class="stepperHeading">
      <img src="../../../../../assets/images/tick.svg" class="circle-image-active" />
      <span class="stepperText-active">Address Info</span>
      <span class="separator-step"></span>
    </div>
    } @else if(stepperCount!=2 ){
    <div class="stepperHeading" (click)="onAddClick()">
      @if(stepperTwoDone){
      <img src="../../../../../assets/images/tick.svg" class="circle-image-active" />}@else{
      <img src="../../../../../assets/images/tick.svg" class="circle-image" />
      }
      <span class="stepperText">Address Info</span>
      <span class="separator-step"></span>
    </div>
    } @if(stepperCount==3){
    <div class="stepperHeading" (click)="onDateClick()">
      <img src="../../../../../assets/images/tick.svg" class="circle-image-active" />
      <span class="stepperText-active">Date & Summary</span>
    </div>
    }@else if(stepperCount!=3 ){
    <div class="stepperHeading" (click)="onDateClick()">
      @if(stepperThreeDone){
      <img src="../../../../../assets/images/tick.svg" class="circle-image-active" />}@else{
      <img src="../../../../../assets/images/tick.svg" class="circle-image" />
      }
      <span class="stepperText">Date & Summary</span>
    </div>
    }
  </div>
  } @if(stepperCount==1){

  <form [formGroup]="personalDetails">
    <div class="input-container d-flex justify-content-between">
      <div class="input-content">
        <span class="input-text">First Name *</span>
        <input type="text" formControlName="fname" placeholder="Enter first name" class="input-div dp-input-control"
          (keydown)="restrictNameInput($event)" />
        @if(stepperOne && personalDetails.get('fname')?.invalid){
        <span class="error-text">Enter First Name</span>
        }
      </div>
      <div class="input-content">
        <span class="input-text">Middle Name</span>
        <input type="text" formControlName="mname" placeholder="Enter middle name" class="dp-input-control input-div"
          (keydown)="restrictNameInput($event)" />
      </div>
      <div class="input-content">
        <span class="input-text">Last Name *</span>
        <input type="text" formControlName="lname" placeholder="Enter last name" class="dp-input-control input-div"
          [matAutocomplete]="auto" (keydown)="restrictNameInput($event)" />
        @if(stepperOne && (personalDetails.get('lname')?.invalid ||
        !selectedLastName)){
        <span class="error-text">Select Last Name from Dropdown</span>
        }

        <mat-autocomplete #auto="matAutocomplete">
          @for (item of surnameList ; track item) {
          <mat-option (click)="onSelectLastNameDropDown(item, 'm')" [value]="item">{{ item }}</mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>

    <div class="input-container d-flex justify-content-between">
      <div class="input-content">
        <span class="input-text">Ritwik's Name</span>

        <input type="text" formControlName="rwname" placeholder="Enter ritwik's name" class="dp-input-control input-div"
          [matAutocomplete]="auto1" />
        <mat-autocomplete #auto1="matAutocomplete">
          @for (item of ritwikList ; track item) {
          <mat-option (click)="onSelectDropDown(item)" [value]="item.wfn">{{ item.wfn }}</mat-option>
          }
        </mat-autocomplete>
        @if((stepperOne && !selectedRitwik &&
        personalDetails.get('rwname')?.value.length!=0 && data==null)||
        (data.row!=undefined && !selectedRitwik)){
        <span class="error-text">Select Ritwik from Dropdown</span>
        }
      </div>
      <div class="input-content">
        <span class="input-text">Family Code *</span>
        <!-- @if(data!=null){
        <input
          type="text"
          formControlName="fc"
          readonly
          placeholder="Enter FC as per Arghya Prasasthi"
          class="dp-input-control input-div"
        /> -->
        <!-- }@else{ -->
        <input type="text" formControlName="fc" placeholder="Enter FC as per Arghya Prasasthi"
          class="dp-input-control input-div" (keydown)="restrictFCInput($event)" [matAutocomplete]="autofc"
          [readonly]="data.row !== undefined" />
        <!-- }  -->
        @if((stepperOne && (personalDetails.get('fc')?.invalid ||
        !selectedFC))){
        <span class="error-text">select member from dropdown</span>

        }
        <mat-autocomplete autoActiveFirstOption #autofc="matAutocomplete">
          @for (item of fcDetails ; track item) {
          <mat-option (click)="onSelectFCDropDown(item)" [value]="item.mem_name">
            <div class="d-flex justify-content-between">
              <span class="name-min-width">
                {{ item.mem_name }}&nbsp;&nbsp;{{ item.mem_surname }}</span>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;
                {{ item.mem_last_transaction_date }}</span>
            </div>
          </mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>

    <div class="input-container d-flex justify-content-between">
      <div class="input-content">
        <span class="input-text">Contact *</span>
        <input type="tel" formControlName="contact" placeholder="Enter Contact No" class="dp-input-control input-div"
          (keydown)="restrictContactInput($event)" />
        @if(stepperOne && personalDetails.get('contact')?.value.length<10 && firstDigit<6) { <span class="error-text">
          Please enter valid phone number</span>
          }
      </div>
      <div class="input-content">
        <span class="input-text">Gender *</span>
        <!--  <select
          #value
          class="dropdown-div"
          formControlName="gender"
          (change)="onGenderSelect(value.value)"
        >
          <option class="option" value="">Select gender</option>
          <option class="option" value="F">Female</option>
          <option class="option" value="M">Male</option>
        </select> -->
        @if(data.row!==undefined){
        <input type="text" formControlName="gender" class="dp-input-control input-div"
          readonly />}@if(data.row===undefined){
        <mat-form-field class="select-mat-form-field">
          <mat-select formControlName="gender" class="custom-mat-select" placeholder="Select gender">
            <mat-option value="F"> Female </mat-option>
            <mat-option value="M"> Male </mat-option>
          </mat-select> </mat-form-field>} @if(stepperOne && personalDetails.get('gender')?.invalid){
        <span class="error-text">select gender from dropdown</span>
        }
      </div>
      @if(show ){
      <div class="input-content">
        <span class="input-text">Marital Status *</span>
        @if(data.row!=undefined && data.maritalStatus!=null){
        <input type="text" formControlName="maritalStatus" placeholder="Select your marital status"
          class="dp-input-control input-div" />
        }@else{
        <!-- <select
          class="dropdown-div"
          (change)="onMarriageSelect($event)"
          formControlName="maritalStatus"
        >
          <option class="option" value="">Select Marital Status</option>
          <option class="option" value="M">Married</option>
          <option class="option" value="U">Unmarried</option></select
        > -->
        <mat-form-field class="select-mat-form-field">
          <mat-select formControlName="maritalStatus" class="custom-mat-select" placeholder="Select marital status">
            <mat-option value="U"> Unmarried </mat-option>
            <mat-option value="M"> Married </mat-option>
          </mat-select>
        </mat-form-field>
        } @if(stepperOne && married==0){
        <span class="error-text">select marital status</span>
        }
      </div>
      }
    </div>
    <div class="input-container d-flex justify-content-between">
      <div class="input-content">
        <span class="input-text">Guardian's First Name*</span>
        <input type="text" formControlName="gfname" placeholder="Enter guardian's first name"
          class="dp-input-control input-div" (keydown)="restrictNameInput($event)" />
        @if(stepperOne && personalDetails.get('gfname')?.invalid ){
        <span class="error-text">Enter guardian's first name</span>
        }
      </div>
      <div class="input-content">
        <span class="input-text">Guardian's Middle Name</span>
        <input type="text" formControlName="gmname" placeholder="Enter guardian's middle name"
          class="dp-input-control input-div" (keydown)="restrictNameInput($event)" />
      </div>
      <div class="input-content">
        <span class="input-text">Guardian's Last Name *</span>
        <input type="text" formControlName="glname" placeholder="Enter guardian's last name"
          class="dp-input-control input-div" [matAutocomplete]="autogl" (keydown)="restrictNameInput($event)" />
        @if(stepperOne && !selectedGuardianLastName ){
        <span class="error-text">Select last name from dropdown</span>
        }
        <mat-autocomplete autoActiveFirstOption #autogl="matAutocomplete">
          @for (item of surnameList ; track item) {
          <mat-option (click)="onSelectLastNameDropDown(item, 'g')" [value]="item">
            {{ item }}</mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>
    @if((married==1 && show) || (show &&
    personalDetails.get('maritalStatus')?.value == 'M')){
    <div class="input-container d-flex justify-content-between">
      <div class="input-content">
        <span class="input-text">Husband's First Name *</span>
        <input type="text" formControlName="hfname" placeholder="Enter Husband's first name"
          class="dp-input-control input-div" (keydown)="restrictNameInput($event)" />
        @if(personalDetails.get('hfname')?.invalid && stepperOne && married==1
        ){
        <span class="error-text">Enter husband's first name</span>}
      </div>
      <div class="input-content">
        <span class="input-text">Husband's Middle Name</span>
        <input type="text" formControlName="hmname" placeholder="Enter Husband's middle name"
          class="dp-input-control input-div" (keydown)="restrictNameInput($event)" />
      </div>
      <div class="input-content">
        <span class="input-text">Husband's Last Name*</span>
        <input type="text" formControlName="hlname" placeholder="Enter Husband's last name"
          class="dp-input-control input-div" (keydown)="restrictNameInput($event)" [matAutocomplete]="autohl" />
        @if(!selectedHusbandLastName && stepperOne && married==1 ){
        <span class="error-text">Select last name from dropdown</span>}

        <mat-autocomplete autoActiveFirstOption #autohl="matAutocomplete">
          @for (item of surnameList ; track item) {
          <mat-option (click)="onSelectLastNameDropDown(item, 'h')" [value]="item">
            {{ item }}</mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>
    }
  </form>
  } @if(stepperCount==2){
  <form [formGroup]="addressDetails">
    <div class="address-div">
      <p class="sub-text">Address at the time of diksha</p>
      <div class="address-details d-flex">
        <div class="address-input">
          <span class="input-text">Address *</span>
          <input type="text" formControlName="dikshaAdd" placeholder="Enter address"
            (keydown)="restrictAddressInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('dikshaAdd')?.invalid ){
          <span class="error-text">Enter address</span>
          }
        </div>
      </div>
      <div class="address-details d-flex addMobver" style="margin-top: 20px">
        <div class="address-input">
          <span class="input-text">Landmark *</span>
          <input type="text" formControlName="dikshaLandMark" placeholder="Enter landmark"
            (keydown)="restrictAddressInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('dikshaLandMark')?.invalid ){
          <span class="error-text">Enter landmark</span>
          }
        </div>
        <div class="address-input">
          <span class="input-text">Pincode *</span>
          <input type="tel" formControlName="dikshaPincode" placeholder="Enter pincode"
            (keydown)="restrictNumberInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('dikshaPincode')?.invalid ){
          <span class="error-text">Enter Pincode</span>
          }
        </div>
      </div>
      <div class="address-details d-flex addMobver" style="margin-top: 20px">
        <div class="address-input">
          <span class="input-text">District</span>
          @if(dikshaDistrictArr.length
          <=1){ <input type="text" formControlName="dikshaDistrict" class="input-div dp-input-control"
            placeholder="Enter Pincode First" readonly />
          }@else{

          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="dikshaDistrict" class="custom-mat-select" placeholder="Select from dropdown">
              <mat-option *ngFor="let item of dikshaDistrictArr" [value]="item">{{ item }}</mat-option>
            </mat-select>
          </mat-form-field>
          } @if(stepperTwo && addressDetails.get('dikshaDistrict')?.invalid ){
          <span class="error-text">Select district from dropdown</span>
          }
        </div>
        <div class="address-input">
          <span class="input-text">State</span>
          @if(dikshaState.length
          <= 1){ <input type="text" formControlName="dikshaState" class="input-div dp-input-control"
            placeholder="Enter Pincode First" readonly />
          }@else{
          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="dikshaState" class="custom-mat-select"
              (selectionChange)="getPinDetails($event, 'dikState')" placeholder="Select from dropdown">
              <mat-option *ngFor="let item of dikshaState" [value]="item">{{ item }}</mat-option>
            </mat-select>
          </mat-form-field>
          } @if(stepperTwo && addressDetails.get('dikshaState')?.invalid ){
          <span class="error-text">Select state from dropdown</span>
          }
        </div>
      </div>
    </div>
    <div class="address-div">
      <p class="sub-text">Present Address</p>
      <div class="address-details d-flex">
        <div class="address-input">
          <span class="input-text">Address *</span>
          <input type="text" formControlName="presAdd" placeholder="Enter address"
            (keydown)="restrictAddressInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('presAdd')?.invalid ){
          <span class="error-text">Enter address</span>
          }
        </div>
      </div>
      <div class="address-details d-flex addMobver" style="margin-top: 20px">
        <div class="address-input">
          <span class="input-text">Landmark *</span>
          <input type="text" formControlName="presLandMark" placeholder="Enter landmark"
            (keydown)="restrictAddressInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('presLandMark')?.invalid ){
          <span class="error-text">Enter landmark</span>
          }
        </div>
        <div class="address-input">
          <span class="input-text">Pincode *</span>
          <input type="tel" formControlName="presPincode" placeholder="Enter pincode"
            (keydown)="restrictNumberInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('presPincode')?.invalid ){
          <span class="error-text">Enter Pincode</span>
          }
        </div>
      </div>
      <div class="address-details d-flex addMobver" style="margin-top: 20px">
        <div class="address-input">
          <span class="input-text">State</span>
          @if(presState.length
          <= 1){ <input type="text" formControlName="presState" placeholder="Enter PIN first"
            class="input-div dp-input-control" readonly />
          }@else{

          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="presState" class="custom-mat-select" placeholder="Select from dropdown"
              (selectionChange)="getPinDetails($event, 'presState')">
              <mat-option *ngFor="let item of presState" [value]="item">{{
                item
                }}</mat-option>
            </mat-select>
          </mat-form-field>
          }
        </div>
        <div class="address-input">
          <span class="input-text">District</span>
          @if(presDistrictArr.length
          <=1){ <input type="text" placeholder="Enter PIN first" formControlName="presDistrict"
            class="input-div dp-input-control" readonly />
          }@else{

          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="presDistrict" class="custom-mat-select" placeholder="Select from dropdown"
              (selectionChange)="onSelectPODropDown($event, 'presDistrict')">
              <mat-option *ngFor="let item of presDistrictArr" [value]="item">{{
                item
                }}</mat-option>
            </mat-select>
          </mat-form-field>
          }
        </div>
       
         <div class="address-input">
          <span class="input-text">Post Office</span>
          @if(presPOArr.length
          <=1){ <input type="text" formControlName="presPO" class="input-div dp-input-control"
            placeholder="Enter Pincode First" readonly />
          @if(stepperTwo && addressDetails.get('presPO')?.invalid ){
          <span class="error-text">selcet PO from dropdown</span>
          } }@else{

          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="presPO" class="custom-mat-select" placeholder="Select from dropdown"
              >
              <mat-option *ngFor="let item of presPOArr" [value]="item">{{
                item
                }}</mat-option>
            </mat-select>
          </mat-form-field>
          @if(stepperTwo && addressDetails.get('presPO')?.invalid ){
          <span class="error-text">Select PO from dropdown</span>
          }}
        </div>
      </div>
    </div>
    <div class="address-div">
      <div class="perm-address-heading d-flex justify-content-between">
        <span class="sub-text">Permanent Address</span>
        <div class="add-checkbox d-flex">
          <label class="custom-checkbox">
            <input type="checkbox" (change)="onCheckboxChange($event)" formControlName="checkbox" />
            <span class="checkmark"></span>
          </label>

          <span class="sub-text">Same as present address</span>
        </div>
      </div>
      <div class="address-details d-flex addMobver" style="margin-top: 20px">
        <div class="address-input">
          <span class="input-text">Address *</span>
          <input type="text" [readonly]="checkBoxClick" formControlName="permAdd" placeholder="Enter address"
            (keydown)="restrictAddressInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('permAdd')?.invalid ){
          <span class="error-text">Enter address</span>
          }
        </div>
      </div>
      <div class="address-details d-flex addMobver" style="margin-top: 20px">
        <div class="address-input">
          <span class="input-text">Landmark *</span>
          <input type="text" [readonly]="checkBoxClick" formControlName="permLandMark"
            (keydown)="restrictAddressInput($event)" placeholder="Enter landmark" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('permLandMark')?.invalid ){
          <span class="error-text">Enter landmark</span>
          }
        </div>
        <div class="address-input">
          <span class="input-text">Pincode *</span>
          <input type="tel" [readonly]="checkBoxClick" formControlName="permPincode" placeholder="Enter pincode"
            (keydown)="restrictNumberInput($event)" class="input-div dp-input-control" />
          @if(stepperTwo && addressDetails.get('permPincode')?.invalid ){
          <span class="error-text">Enter Pincode</span>
          }
        </div>
      </div>

      <div class="address-details d-flex addMobver" style="margin-top: 20px">
       
        <div class="address-input">
          <span class="input-text">State</span>
          @if(permState.length
          <= 1){ <input type="text" formControlName="permState" placeholder="Enter PIN first"
            class="input-div dp-input-control" readonly />
          }@else{
          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="permState" class="custom-mat-select" placeholder="Select from dropdown"
              (selectionChange)="getPinDetails($event, 'permState')" [disabled]="checkBoxClick">
              <mat-option *ngFor="let item of permState" [value]="item" [disabled]="checkBoxClick">{{ item
                }}</mat-option>
            </mat-select>
          </mat-form-field>
          }
        </div>
        <div class="address-input">
          <span class="input-text">District</span>
          @if(permDistrictArr.length
          <=1){ <input type="text" formControlName="permDistrict" class="input-div dp-input-control"
            placeholder="Enter PIN first" readonly />
          }@else{
          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="permDistrict" class="custom-mat-select" placeholder="Select from dropdown"
              (selectionChange)="onSelectPODropDown($event, 'permDistrict')" [disabled]="checkBoxClick">
              <mat-option *ngFor="let item of permDistrictArr" [value]="item" [disabled]="checkBoxClick">{{ item
                }}</mat-option>
            </mat-select>
          </mat-form-field>
          }
        </div>
         <div class="address-input">
          <span class="input-text">Post Office</span>
          @if(permPOArr.length
          <=1){ <input type="text" formControlName="permPO" class="input-div dp-input-control"
            placeholder="Enter pincode first" readonly />

          }@else{

          <mat-form-field class="select-mat-form-field">
            <mat-select formControlName="permPO" class="custom-mat-select" placeholder="Select from dropdown"
               [disabled]="checkBoxClick">
              <mat-option *ngFor="let item of permPOArr" [value]="item" [disabled]="checkBoxClick">{{ item
                }}</mat-option>
            </mat-select>
          </mat-form-field>
          @if(stepperTwo && addressDetails.get('permPO')?.invalid ){
          <span class="error-text">Select PO from dropdown</span>
          } }
        </div>
      </div>
    </div>
  </form>
  } @if(stepperCount==3){
  <form [formGroup]="dateDetails">
    <div class="date-div d-flex justify-content-between">
      <div class="input-content">
        <span class="input-text">Date of Birth *</span>
        <input type="date" class="dp-input-control input-div" placeholder="YYYY-MM-DD" formControlName="dob"
          maxlength="10" [max]="maxDate" />
        @if(stepperThree && dateDetails.get('dob')?.invalid ){
        <span class="error-text">Enter date of birth</span>
        }
      </div>

      <div class="input-content">
        <span class="input-text">Year of Diksha *</span>

        <mat-form-field class="select-mat-form-field">
          <mat-select formControlName="dikshaYear" class="custom-mat-select">
            <mat-option *ngFor="let year of years" [value]="year">{{
              year
              }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="input-content">
        <span class="input-text">Month of Diksha</span>
        <mat-form-field appearance="fill">
          <mat-select formControlName="dikshaMonth">
            <mat-option [value]="">None</mat-option>
            <mat-option *ngFor="let month of months" [value]="month.value">{{
              month.viewValue
              }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="input-content">
        <span class="input-text">Day of Diksha</span>
        <mat-form-field appearance="fill">
          <mat-select formControlName="dikshaDay">
            <mat-option [value]="">None</mat-option>
            <mat-option *ngFor="let day of days" [value]="day">{{
              day
              }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="textarea-div d-flex">
      <div class="textarea-heading d-flex justify-content-between">
        <span class="input-text">Comments </span>
        <span class="input-text">{{ commentsLetterCount }}/120</span>
      </div>
      <textarea class="textarea-input dp-input-control" formControlName="comments"
        placeholder="Enter your comment"></textarea>
      @if(stepperThree && dateDetails.get('comments')?.invalid ){
      <span class="error-text">Enter your comment</span>
      }
    </div>
  </form>
  }
  <div class="button-div d-flex justify-content-end">
    @if(stepperCount==1){
    <button class="button-text dp-primary-btn-disabled" (click)="onPreviousClick()" disabled>
      Previous</button>}@else{
    <button class="button-text dp-secondary-btn" (click)="onPreviousClick()">
      Previous
    </button>
    }@if(stepperCount==1){
    <button class="button-text dp-primary-btn" (click)="onNextClick()">
      Next</button>} @else if(stepperCount==2){
    <button class="button-text dp-primary-btn" (click)="onSecondNextClick()">
      Next
    </button>
    }@else{ @if(data.row!=undefined){ @if(data.new){
    <button class="button-text dp-primary-btn" (click)="onSubmitClick()">
      Submit to DPNF
    </button>
    } @else {
    <button class="button-text dp-primary-btn" (click)="onSaveClick()">
      Save Changes
    </button>
    } }@else{
    <button class="button-text dp-primary-btn" (click)="onSubmitClick()">
      Submit to DPNF</button>} }
  </div>
</div>
<app-loader [isLoading]="isLoading"></app-loader>